module.exports = __webpack_public_path__ + "static/images/event/Flag1_Left_Chartreuse.png";